import { Stack } from "@mui/material";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";

export default function Footer(props) {
  const [t, i18n] = useTranslation("global");

  return (
    <>
      {/* Exterior Box */}
      <Box>
        {/* Box with black background */}
        <Box
          sx={{
            display: "flex",
            backgroundColor: "black",
            width: "100%",
            height: "100%",
            justifyContent: "space-between",
            padding: "5px",
            flexDirection: { xs: "column", sm: "row" },
          }}
        >
          {/* Box with logo and copyright*/}
          <Box display="flex" flexDirection="column">
            <Box
              component="a"
              href="/"
              sx={{
                flexGrow: 0.6,
                display: "block",
                pl: { xs: 4, sm: 10 },
                pt: 4,
              }}
            >
              <img src="/logo.png" alt="logo" width="200px" height="50px" />
            </Box>
            <Typography
              variant="caption"
              color="white"
              sx={{
                pl: { xs: 4, sm: 10 },
                pt: { xs: 2, sm: 0 },
                opacity: 0.8,
                fontWeight: 100,
              }}
            >
              {t("Footer.titleEcos")}, {t("Footer.allRights")}
            </Typography>
          </Box>

          <Box
            display="flex"
            gap={7}
            sx={{
              pt: 4,
              flexGrow: 0.4,
              flexDirection: { xs: "column", sm: "row" },
              pl: { xs: 4, sm: 0 },
              pb: 4,
            }}
          >
            {/* Services box */}
            <Stack sx={{ flexGrow: 0.1 }} gap={0.1}>
              <Typography variant="subtitle1" fontWeight="bold" color="white">
                {t("Footer.servicios")}
              </Typography>
              <CustomTypo href="/toDoor">{t("Header.toDoor")}</CustomTypo>
              <CustomTypo href="/pickUpPoint">
                {t("Header.lockerPudo")}
              </CustomTypo>
              <CustomTypo href="/tracking/1">
                {t("Footer.sigue-tu-pedido")}
              </CustomTypo>
            </Stack>

            {/* Contact us box */}
            <Stack sx={{ flexGrow: 0.1 }} gap={0.1}>
              <CustomBold>{t("Footer.contactanos")}</CustomBold>
              <CustomTypo href="/atencionCliente">
                {t("Footer.servicio-al-cliente")}
              </CustomTypo>
              <CustomTypo href={t("ChatBot.urlChat")}>
                {t("Footer.chatea-con-nosotros")}
              </CustomTypo>
              <CustomTypo href="/atencionCliente#faq">
                {t("Footer.preguntas-frecuentes")}
              </CustomTypo>
            </Stack>

            {/* Legal Box */}
            <Stack sx={{ flexGrow: 0.1 }} gap={0.1}>
              <CustomBold>{t("Footer.legal")}</CustomBold>
              <CustomTypo href="/aviso-legal">
                {t("Footer.aviso-legal-url")}
              </CustomTypo>
              <CustomTypo href="/politica-privacidad">
                {t("Footer.politica-privacidad-url")}
              </CustomTypo>
              <CustomTypo href="/politica-cookies">
                {t("Footer.politica-cookies-url")}
              </CustomTypo>
            </Stack>
          </Box>
        </Box>

        {/* Bottom Border Colors */}
        <Box
          sx={{
            borderBottom: "7px solid #0081ED",
          }}
        />

        <Box
          sx={{
            borderBottom: "7px solid #84C7FF",
          }}
        />
      </Box>
    </>
  );
}

const CustomBold = ({ children }) => {
  return (
    <Typography variant="subtitle1" fontWeight="bold" color="white">
      {children}
    </Typography>
  );
};

const CustomTypo = ({ children, href }) => {
  return (
    <Typography
      component="a"
      href={href}
      variant="caption"
      color="white"
      sx={{ opacity: 0.8, fontWeight: 100 }}
    >
      <br />
      {children}
    </Typography>
  );
};
